export class Tube {
    position:Array<number>;
    rotation:Array<number>;
    trajectory:(t:number)=>Array<number>;
    constructor() {
        this.position = [0.0,0.0,0.0];
        this.rotation = [0.0,0.0,0.0];
        this.trajectory = (t:number) => {
            return[2.0*Math.cos(t),2.0*Math.sin(t),0.0];
        }
    }
    GenerateVerticesAndIndices(t:number,rad:number,divC:number,divTrail:number){
        const vertices = [] as Array<number>;
        const indices = [] as Array<number>;
        for(let i = 0; i < divTrail; i++){
            const center = this.trajectory(t - 0.01 * i);
            const center_d= this.trajectory(t - 0.01 * i+0.01);
            const normal = [center_d[0]-center[0],center_d[1]-center[1],center_d[2]-center[2]];
            const n_l = Math.sqrt(normal[0]*normal[0]+normal[1]*normal[1]+normal[2]*normal[2]);
            normal[0] /= n_l;
            normal[1] /= n_l;
            normal[2] /= n_l;
            let vecA = [1.0,0.0,0.0];
            if(normal[1]*normal[1]+normal[2]*normal[2] > 0.0001){
                vecA = [0.0,-normal[2]/Math.sqrt(normal[1]*normal[1]+normal[2]*normal[2]),normal[1]/Math.sqrt(normal[1]*normal[1]+normal[2]*normal[2])];
            }
            const vecB = [normal[2]*vecA[1]-normal[1]*vecA[2],normal[0]*vecA[2]-normal[2]*vecA[0],normal[1]*vecA[0]-normal[0]*vecA[1]];
            for(let j = 0; j < divC; j++){
                const theta = 2 * Math.PI * j / divC;
                const vecR = [
                    center[0] + vecA[0] * (Math.cos(theta)*rad+this.position[0]) + vecB[0] * (Math.sin(theta)*rad+this.position[1]),
                    center[1] + vecA[1] * (Math.cos(theta)*rad+this.position[0]) + vecB[1] * (Math.sin(theta)*rad+this.position[1]),
                    center[2] + vecA[2] * (Math.cos(theta)*rad+this.position[0]) + vecB[2] * (Math.sin(theta)*rad+this.position[1])
                ]
                vertices.push(vecR[0],vecR[1],vecR[2]);
            }
        }
        for(let i = 0; i < divTrail-1; i++){
            for(let j = 0; j < divC; j++){
                indices.push(i * divC + j,(i+1)*divC + j,i * divC + (j+1)%divC);
                indices.push(i * divC + (j+1)%divC,(i+1)*divC + j,(i+1) * divC + (j+1)%divC);
            }
        }
        return[vertices,indices];
    }



}